*,
*::before,
*::after {
  box-sizing: border-box;
}

:host {
  display: inline-block;
}

:host([disabled]) {
  cursor: not-allowed;
  opacity: 0.4;
}

.wui-input-inner {
  position: relative;

  display: flex;
  gap: 4px;
  align-items: center;

  box-sizing: border-box;
  width: var(--wui-input-width, 200px);
  min-width: var(--wui-control-size, 40px);
  height: var(--wui-control-size, 40px);
  padding: 0 4px;
  border-radius: calc(infinity * 1px);

  transition:
    border-color var(--wui-duration-focus, 200ms),
    box-shadow var(--wui-duration-focus, 200ms);
}

:host([focused]) .wui-input-inner {
  --wui-internal-glass-focus-ring:
    inset 0 0 0 1px var(--wui-color-accent, #08f),
    0 0 0 var(--wui-focus-ring-width, 3px) var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
}

input {
  flex: 1;

  min-width: 48px;
  height: 100%;
  margin: 0;
  padding: 0;
  border: none;

  /* 表单控件不继承字体；显式继承以对齐宿主排版，避免 UA 默认字体差异 */
  font: inherit;
  font-size: var(--wui-font-size, 14px);
  color: var(--wui-color-text, #1b1b1b);
  text-align: center;

  background: transparent;
  outline: none;

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    margin: 0;
    appearance: none;
  }

  &[type='number'] {
    appearance: textfield;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }
}

.num-btn {
  cursor: pointer;

  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;

  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: calc(infinity * 1px);

  color: var(--wui-color-text-secondary, #6a6a6a);

  background: transparent;

  transition: background-color var(--wui-duration-trigger, 160ms) ease;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  &:focus-visible {
    outline: var(--wui-focus-ring-width, 3px) solid var(--wui-color-focus-ring, rgb(0 136 255 / 0.4));
    outline-offset: 2px;
  }
}

@media (hover: hover) and (pointer: fine) {
  .num-btn:hover:not(:disabled) {
    background: var(--wui-color-state-layer-hover, color-mix(in srgb, var(--wui-color-text, #1b1b1b) 6%, transparent));
  }
}

.num-btn:active:not(:disabled) {
  background: var(--wui-color-state-layer-active, color-mix(in srgb, var(--wui-color-text, #1b1b1b) 15%, transparent));
}

@media (prefers-reduced-motion: reduce) {
  .num-btn {
    transition: background-color var(--wui-duration-trigger, 160ms) ease;
  }
}
